import db from '@/db'
import { computed, onMounted, ref, watchEffect } from 'vue'
import { useFlashcards } from './useFlashcards'

export function useHome() {
  const { loadFlashcards, flashcardsLeft } = useFlashcards()
  const isLoading = ref(false)
  const totalKanjisCount = ref(0)
  const shownUserKanjis = ref<string[]>([])
  const shownKanjisCount = computed(() => shownUserKanjis.value.length)
  const shownWordsCount = ref(0)
  const totalWordsCount = ref(0)
  const flashcardsForReviewCount = ref(0)

  async function load() {
    isLoading.value = true
    await loadFlashcards()
    flashcardsForReviewCount.value = flashcardsLeft.value
    shownUserKanjis.value = (await db.userKanjis.toArray())
      .filter((item) => item.shouldShow)
      .map((item) => item.kanji)
    totalKanjisCount.value = await db.kanjis.count()
    const words = await db.words.toArray()
    totalWordsCount.value = words.length
    shownWordsCount.value = words.filter((item) =>
      item.kanjiSet.every((ch) => shownUserKanjis.value.includes(ch)),
    ).length

    isLoading.value = false
  }

  onMounted(() => load())

  return {
    isLoading,
    shownKanjisCount,
    shownWordsCount,
    flashcardsForReviewCount,
    totalKanjisCount,
    totalWordsCount,
  }
}
